import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { ApiVersion } from 'apiConnector/tabs/tabs.model';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, takeUntil, withLatestFrom } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import type { TabsForWorkspace } from 'state/workspaces/model';
import {
  workspaceTabContentFetched,
  workspaceTabContentFetchFailed,
} from 'state/workspaces/tabContent/tabContent.actions';
import {
  batchWorkspaceTabInitThunk,
  workspaceWithProductSelectorTabInitThunk,
} from 'state/workspaces/workspace.thunks';

import { tabRemoved } from './tabRemoved';

export function fetchTabContentEpic(): EpicWithThunk {
  return (actions$, state$, { httpClient }) =>
    actions$.pipe(
      ofType('WORKSPACE_TAB_CONTENT_FETCH_REQUESTED'),
      withLatestFrom(state$),
      mergeMap(([{ tabId, workspace, tabType }]) => {
        const api = tabsApiConnector(httpClient, workspace);
        const tabRemoved$ = tabRemoved(actions$, tabId, state$);

        const shouldUseV2 = workspace === 'essential';
        const apiVersion: ApiVersion = shouldUseV2 ? ApiVersion.V2 : ApiVersion.V1;

        return api.getTabContent(tabId, apiVersion).pipe(
          takeUntil(tabRemoved$),
          map(tabContent => workspaceTabContentFetched(tabId, tabContent, workspace, tabType)),
          catchError((_: Error) => {
            switch (workspace) {
              case 'newBatch':
                return of(batchWorkspaceTabInitThunk(tabId), workspaceTabContentFetchFailed(tabId, workspace));
              case 'static':
                return of(
                  workspaceWithProductSelectorTabInitThunk(tabId, workspace),
                  workspaceTabContentFetchFailed(tabId, workspace, undefined, tabType as TabsForWorkspace['static']),
                );
              case 'essential':
                return of(
                  workspaceWithProductSelectorTabInitThunk(tabId, workspace),
                  workspaceTabContentFetchFailed(tabId, workspace, undefined, tabType as TabsForWorkspace['essential']),
                );
              default:
                return of(workspaceTabContentFetchFailed(tabId, workspace));
            }
          }),
        );
      }),
    );
}
